// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"fd22e968","417":"4e4f83b9","639":"2f8bc1fc","679":"de049a25","729":"3e38cf12","830":"ea22752b","878":"f1677c6b"}[chunkId] + ".chunk.js";
};